import { Box, Flex, Text } from '@chakra-ui/react';

import ArticleContent from '@/components/Article/articleContent';
import { ProductCard } from '@/components/Card/ProductCard';
import { H2 } from '@/components/Heading';

import { Promotion } from '@/models/api/SuperOffer';

type SuperOfferProps = { promotion: Promotion };

export const SuperOfferCard = ({ promotion }: SuperOfferProps) => {
    const {
        product,
        grossPriceAfterDiscount,
        netPriceAfterDiscount,
        promotionTitle,
        promotionDescription,
        promotionConditionsDescription
    } = promotion;
    const cardRadius = 36;

    return (
        <Flex
            alignItems={{
                sm: 'flex-start'
            }}
            borderRadius={cardRadius}
            bgColor="grey.100"
            p={6}
            gap={9}
            mb={5}
            flexWrap={{
                sm: 'wrap'
            }}
            flexDirection={{
                base: 'column',
                sm: 'row'
            }}
        >
            <Box
                borderRadius="inherit"
                bgColor="white"
                p={1.5}
                maxW={{
                    md: 326
                }}
                flex={1}
                overflow="hidden"
            >
                <ProductCard
                    code={product.code}
                    slug={product.slug}
                    grossPrice={grossPriceAfterDiscount.toString()}
                    grossPriceBeforeDiscount={product.grossPriceBeforeDiscount?.toString()}
                    lowestPriceIn30Days={product.lowestPriceIn30Days}
                    isNew={product.new}
                    netPrice={netPriceAfterDiscount.toString()}
                    points={0}
                    title={product.title}
                    mainImage={product.mainImage}
                    netUnitPrice={product.netUnitPrice}
                    netPromoPrice={product.netPromoPrice}
                    currency={product.currency}
                    productAvailableForSale={product.productAvailableForSale}
                    discount={product.discount}
                    unit={product.unit}
                    categories={product.categories}
                    sale={product.sale}
                    addToCart={false}
                    imageWrapperProps={{
                        borderRadius: 36,
                        overflow: 'hidden'
                    }}
                    imageProps={{
                        width: 1000
                    }}
                    detailsProps={{
                        px: 4,
                        pb: 8
                    }}
                    linkToProductPage={false}
                    favourite={product.favourite}
                    showFavourite={false}
                />
            </Box>
            <Box flex={1}>
                <H2 as="h3">{promotionTitle}</H2>
                <Text fontWeight="bold" mb={6}>
                    {promotionConditionsDescription}
                </Text>
                <ArticleContent content={promotionDescription} styles={{ padding: 0, margin: 0 }} />
            </Box>
        </Flex>
    );
};
